import getPageInfo from './get-page-info';

/**
 * The page an event happened on: `path`, the name admin's events use, and
 * `page_name`, Studio's own page taxonomy, the one the page views carry.
 */
export function pageProperties(pathname: string) {
  return {
    path: pathname,
    page_name: getPageInfo(pathname)?.pageName ?? null,
  };
}

/**
 * What every Studio track event carries on top of its own properties: the app,
 * so one Amplitude chart reads admin's and Studio's events side by side, and the
 * page. A value the event sets itself wins, which is how a chat turn keeps the
 * page it was sent from.
 *
 * Not `url` or `referrer`: Segment already sends both under `context.page`, and
 * the full URL would copy query strings (filters, the OAuth `code`) into the
 * properties of every event.
 */
export function withStudioDefaults(
  properties: Record<string, unknown> | undefined,
  pathname: string
) {
  return { app: 'studio', ...pageProperties(pathname), ...(properties ?? {}) };
}

export interface SourceMiddlewareContext {
  payload: {
    obj: { type?: string; properties?: Record<string, unknown> };
  };
  next: (payload: SourceMiddlewareContext['payload']) => void;
}

/**
 * A Segment source middleware applying `withStudioDefaults` to every track call,
 * whoever makes it: the store, the guides forwarder, anything added later.
 */
export function studioEventDefaults(pathname: () => string) {
  return ({ payload, next }: SourceMiddlewareContext) => {
    if (payload.obj.type === 'track') {
      payload.obj.properties = withStudioDefaults(
        payload.obj.properties,
        pathname()
      );
    }
    next(payload);
  };
}
